module.exports = __webpack_public_path__ + "static/media/Muli-Regular.328d5579.ttf";